import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';

import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { Image } from '@sravni/react-image';

import styles from './EbsInformer.module.scss';

type TImageStyles = Omit<CSSProperties, 'translate' | 'width' | 'height'>;

export interface IEbsInformerProps {
  title: string | ReactNode;
  step?: number;
  image?: string;
  subtitle?: ReactNode;
  imageSize?: { width: number; height: number };
  imageStyles?: TImageStyles;
}

export function EbsInformer({ step, title, image, subtitle, imageSize, imageStyles }: IEbsInformerProps) {
  return (
    <div className={classNames(styles.container, { [styles.full]: !!image })}>
      <div className={styles.content}>
        <Badge text={`Шаг ${step}`} variant="primary" />
        <Text>{title}</Text>
        {subtitle && subtitle}
      </div>

      {image && (
        <div className={styles.imageContainer}>
          <Image width={imageSize.width} height={imageSize.height} style={imageStyles} src={image} />
        </div>
      )}
    </div>
  );
}
